"use client"

import type { ReactNode } from "react"
import type { PartnerCapability } from "@/schema/company"

import { usePartnerAccess } from "@/hooks/use-partner-access"

export function PartnerAccessDisabled({ message }: { message: string }) {
  return (
    <div role="status" className="text-muted-foreground p-4 text-center text-sm">
      <p>{message}</p>
    </div>
  )
}

export function PartnerAccessGate({
  capability,
  disabledMessage,
  children,
}: {
  capability: PartnerCapability
  disabledMessage: string
  children: ReactNode
}) {
  const { enabled, isLoading } = usePartnerAccess(capability)
  if (isLoading) return null
  return enabled ? children : <PartnerAccessDisabled message={disabledMessage} />
}
